import { mutatorAction } from 'satcheljs';
import { inlineFeedbackDialogStore } from '../store/store';

export let setShowInlineFeedbackDialog = mutatorAction(
    'setShowInlineFeedbackDialog',
    (showInlineFeedbackDialog: boolean) => {
        let store = inlineFeedbackDialogStore();
        store.showInlineFeedbackDialog = showInlineFeedbackDialog;
    }
);
